module.exports = __webpack_public_path__ + "img/mm-logo.51bcea26.svg";